import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d95b556"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 跟进标记 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Ellipsis = _resolveComponent("Ellipsis")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_table, {
        data: _ctx.orderState.tableData,
        stripe: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "order_id",
            label: "预约单号"
          }),
          _createVNode(_component_el_table_column, {
            label: "用户来源",
            width: "100px"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(scope.row.user?.source_origin), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "created_at",
            label: "提交时间"
          }),
          _createVNode(_component_el_table_column, { label: "试驾门店" }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(scope.row.test_drive_location), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "mobile_number",
            label: "预约电话"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(scope.row.mobile_number), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "models",
            label: "意向试驾车型"
          }),
          _createVNode(_component_el_table_column, {
            prop: "test_drive_at",
            label: "预约试驾时间"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(`${scope.row.test_drive_at} ${scope.row.test_drive_time_type_name}`), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "remark",
            label: "跟进备注"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_Ellipsis, {
                content: scope.row?.remark ?? ''
              }, null, 8, ["content"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "handler_name",
            label: "处理人"
          }),
          _createVNode(_component_el_table_column, { label: "管理" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.handleShowConfirmDialog(scope.row)),
                type: "text"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_pagination, {
        style: {"padding":"20px 0","text-align":"right"},
        background: "",
        layout: "total, prev, pager, next",
        total: _ctx.orderState.totalCount,
        "current-page": _ctx.orderState.searchOptions.page,
        "page-size": _ctx.orderState.searchOptions.count,
        onCurrentChange: _ctx.handlePageChange
      }, null, 8, ["total", "current-page", "page-size", "onCurrentChange"])
    ])
  ]))
}